export const focus = {
  base: 'focus-visible:outline-surface-9 focus-visible:ring-surface-5 focus-visible:ring-4 outline-transparent outline',
  invalid:
    'focus-visible:aria-invalid:border-destructive/64 focus-visible:aria-invalid:ring-destructive/48 ',
};
